import { DateTypeClassificationFilter } from '../Features/Classification/enum/DateTypeClassificationFilter';

export interface FilterClassificationModel {
    clientId: number | null,
    classificationIdList: number[],
    classificationMetricIdList: number[],
    responsibleId: number | null,
    publicationTitle: string,
    startDate: Date | null,
    endDate: Date | null,
    dateType: DateTypeClassificationFilter,
    vehicleId: number[],
    contentId: number[],
    keywordId: number[],
    organogramId: number[],
    removedNews: boolean
}

export const filterClassificationModelInitial: FilterClassificationModel = {
    clientId: null,
    classificationIdList: [],
    classificationMetricIdList: [],
    responsibleId: null,
    publicationTitle: '',
    startDate: null,
    endDate: null,
    dateType: DateTypeClassificationFilter.NONE,
    vehicleId: [],
    contentId: [],
    keywordId: [],
    organogramId: [],
    removedNews: false
};